import React from 'react';
import { Drawer, IconButton, Box, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Header from './Header'; // Assumes Header.js is in the same folder

const FullScreenDrawer = ({ open, onClose, children, height = '100vh', title }) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        sx: {
          height: height,
          width: '100%',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          overflow: 'auto',
          p: 2,
          boxSizing: 'border-box',
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {title ? <Header label={title} /> : <span />}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Box sx={{ mt: 2 }}>
          {children}
        </Box>
      </Box>
    </Drawer>
  );
};

export default FullScreenDrawer;
